<script>
export default {
  name: 'SideLeft',
}
</script>

<template>
  <div class="side-left">
    <div>
      <div class="label">
      <img src="@/assets/images/home-page/pc/logo_pc.png" />
    </div>
    <div class="img-text">
      <p>
        アサヒグループ食品を知って頂くための <br>
        コンテンツが盛りだくさん！
      </p>
    </div>
    <div class="logo">
      <a href="https://fun.asahi-gf.co.jp/" target="_blank">
        <img src="@/assets/images/home-page/pc/banner_toasahi_pc.png" />
      </a>
    </div>
    </div>
    
  </div>
  
</template>

<style lang="scss" scoped>
@import 'side-left.scss';
</style>
